export default "__VITE_ASSET__DLgeJpXt__"